import { PropsWithChildren } from "react";
import { Layout } from "~/components/layout";
import { ProfileModal } from "~/components/modal/ProfileModal";
import { SessionContext, useAuth } from "~/contexts/AuthContext";
import { TrendsContextProvider } from "~/contexts/TrendsContext";
import { TermsAcceptanceOverlay } from "~/pages/Login/components/TermsAcceptanceOverlay";
import { ProjectsContextProvider } from "~/pages/Projects/contexts/ProjectsContext";

export function AppLayout({ children }: PropsWithChildren) {
  const { session } = useAuth();

  // Signing out clears the session before the guard redirects to the login page.
  if (!session) {
    return null;
  }

  return (
    <SessionContext value={session}>
      <TrendsContextProvider>
        <ProjectsContextProvider>
          <Layout>
            {children}
            <ProfileModal />
          </Layout>
        </ProjectsContextProvider>
      </TrendsContextProvider>
      <TermsAcceptanceOverlay />
    </SessionContext>
  );
}
